export default "__VITE_ASSET__7YrxzfGp__"